import './App.css';
import MainContainer from "./Components/MainContainer/index" 
import Header from "./Components/Header" 


function App() {
  return (
    <div className="App">
      <Header/>
    <MainContainer/>
    </div>
  );
}

export default App;
